import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Urls } from 'kts-platform-frame/entry/constant';
import { withRouter } from 'kts-platform-frame/routes';
import { Form, Button, Row, Col, Input, Select, DatePicker, Divider, Icon, Spin } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';
// 订单
import OrderFormBasicInfo from './UI.OrderFormBasicInfo';
import OrderFormTable from './UI.OrderFormTable';
import OrderFormAdditional from './UI.OrderFormAdditional';
// 计划单
import ForecastFormBasicInfo from './UI.ForecastFormBasicInfo';
import ForecastFormTable from './UI.ForecastFormTable';
import ForecastFormAdditional from './UI.ForecastFormAdditional';
// 发货单
import DespatchAdviceFormBasicInfo from './UI.DespatchAdviceFormBasicInfo';
import DespatchAdviceFormTable from './UI.DespatchAdviceFormTable';
import DespatchAdviceFormAdditional from './UI.DespatchAdviceFormAdditional';
// 收货单
import ReceiptAdviceFormBasicInfo from './UI.ReceiptAdviceFormBasicInfo';
import ReceiptAdviceFormTable from './UI.ReceiptAdviceFormTable';
import ReceiptAdviceFormAdditional from './UI.ReceiptAdviceFormAdditional';
// 入库单
import StockInNoticeFormBasicInfo from './UI.StockInNoticeFormBasicInfo';
import StockInNoticeFormTable from './UI.StockInNoticeFormTable';
import StockInNoticeFormAdditional from './UI.StockInNoticeFormAdditional';
// 合同
import ContractFormBasicInfo from './UI.ContractFormBasicInfo';
import ContractFormTable from './UI.ContractFormTable';
import ContractFormAdditional from './UI.ContractFormAdditional';

import ModulesFormAction from './Modules.Form.Action';

import BillModelData from '../ModelData';

const { documentType, role, status } = BillModelData;
const Option = Select.Option;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    loadingUrls?: Map<Urls, string>;
}

/** 绑定全局数据到props */
@withRouter
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    // public formList: any[] = [];
    public total: any = 0;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { loadingUrls } = this.props;
        // 订单发送小计时 不加loading效果
        let isCalculate = false;
        loadingUrls.forEach((item) => {
            if (item === "/document/v2/calculate") {
                isCalculate = true;
            }
        });

        const { form } = this.props; // 获取你的props数据
        const { getFieldDecorator } = form;
        // 判断是否 是子类型
        let documentName = this.modulesState.documentType;
        return (
            <Spin spinning={loadingUrls.size > 0 && !isCalculate}>
                <div className={css.creatBill}>
                    <div className={css.header}>
                        <div className={css.title}>
                            <div className={css.crumbs}>
                                <span style={{ cursor: 'pointer' }} onClick={() => ModulesAction.goBack()}>单据</span> {'>'}
                            {documentType[documentName]}
                            </div>
                            <div className={css.titleType}>{documentType[documentName]}</div>
                        </div>
                        <div className={css.goBack}>
                            <Button className="kts-but-default" key="back" onClick={() => ModulesAction.goBack()}>返回</Button>
                        </div>
                    </div>
                    {
                        this.modulesState.documentType === 'Order' &&
                        <div className={css.content}>
                            <OrderFormBasicInfo ref={e => { e && this.modulesState.formList.push(e); }} />
                            {!this.modulesState.orderForm.Lines.length && <Divider />}
                            {
                                this.getOrderTableList()
                            }
                            <Row gutter={20}>
                                <Col span={18} offset={2}>
                                    <Button
                                        className="kts-but-primary"
                                        onClick={ModulesAction.addCommonFormTable}
                                    >
                                        添加一行
                                    </Button>
                                </Col>
                            </Row>
                            <Divider />
                            <p className={css.total}>总计： {this.modulesState.orderForm.Total}</p>
                            <OrderFormAdditional ref={e => { e && this.modulesState.formList.push(e); }} />
                            <div className={css.footer}>
                                <Button htmlType="submit" className="kts-but-default" onClick={this.handleSubmitOrder}>保存</Button>
                                <Button htmlType="submit" className="kts-but-general" onClick={this.sendSubmitOrder} style={{ margin: '0 12px' }}><Icon type="ceshifasong" />发送</Button>
                            </div>
                        </div>
                    }
                    {
                        (this.modulesState.documentType === 'ForecastPrediction' || this.modulesState.documentType === 'ForecastDemand') &&
                        <div className={css.content}>
                            <ForecastFormBasicInfo ref={e => { e && this.modulesState.formList.push(e); }} />
                            {!this.modulesState.forecastForm.Lines.length && <Divider />}
                            {
                                this.getForecastTableList()
                            }
                            <Row gutter={20}>
                                <Col span={18} offset={2}>
                                    <Button
                                        className="kts-but-primary"
                                        onClick={ModulesAction.addCommonFormTable}
                                    >
                                        添加一行
                                    </Button>
                                </Col>
                            </Row>
                            <Divider />
                            <ForecastFormAdditional ref={e => { e && this.modulesState.formList.push(e); }} />
                            <div className={css.footer}>
                                <Button htmlType="submit" className="kts-but-default" onClick={this.handleSubmitForecast}>保存</Button>
                                <Button htmlType="submit" className="kts-but-general" onClick={this.sendSubmitForecast} style={{ margin: '0 12px' }}><Icon type="ceshifasong" />发送</Button>
                            </div>
                        </div>
                    }
                    {
                        this.modulesState.documentType === 'DespatchAdvice' &&
                        <div className={css.content}>
                            <DespatchAdviceFormBasicInfo ref={e => { e && this.modulesState.formList.push(e); }} />
                            {!this.modulesState.despatchAdviceForm.Lines.length && <Divider />}
                            {
                                this.getDespatchAdviceTableList()
                            }
                            <Row gutter={10}>
                                <Col span={18} offset={2}>
                                    <Button
                                        className="kts-but-primary"
                                        onClick={ModulesAction.addCommonFormTable}
                                    >
                                        添加一行
                                    </Button>
                                </Col>
                            </Row>
                            <Divider />
                            <DespatchAdviceFormAdditional ref={e => { e && this.modulesState.formList.push(e); }} />
                            <div className={css.footer}>
                                <Button htmlType="submit" className="kts-but-default" onClick={this.handleSubmitDespatchAdvice}>保存</Button>
                                <Button htmlType="submit" className="kts-but-general" onClick={this.sendSubmitDespatchAdvice} style={{ margin: '0 12px' }}><Icon type="ceshifasong" />发送</Button>
                            </div>
                        </div>
                    }
                    {
                        (
                            this.modulesState.documentType === 'ReceiptAdvice'
                            || this.modulesState.documentType === 'ReceiptAdviceRATC01'
                            || this.modulesState.documentType === 'ReceiptAdviceReturn'
                        ) &&
                        <div className={css.content}>
                            <ReceiptAdviceFormBasicInfo ref={e => { e && this.modulesState.formList.push(e); }} />
                            {!this.modulesState.receiptAdviceForm.Lines.length && <Divider />}
                            {
                                this.getReceiptAdviceTableList()
                            }
                            <Row gutter={20}>
                                <Col span={18} offset={1}>
                                    <Button
                                        className="kts-but-primary"
                                        onClick={ModulesAction.addCommonFormTable}
                                    >
                                        添加一行
                                    </Button>
                                </Col>
                            </Row>
                            <Divider />
                            <ReceiptAdviceFormAdditional ref={e => { e && this.modulesState.formList.push(e); }} />
                            <div className={css.footer}>
                                <Button htmlType="submit" className="kts-but-default" onClick={this.handleSubmitReceiptAdvice}>保存</Button>
                                <Button htmlType="submit" className="kts-but-general" onClick={this.sendSubmitReceiptAdvice} style={{ margin: '0 12px' }}><Icon type="ceshifasong" />发送</Button>
                            </div>
                        </div>
                    }
                    {
                        this.modulesState.documentType === 'StockInNotice' &&
                        <div className={css.content}>
                            <StockInNoticeFormBasicInfo ref={e => { e && this.modulesState.formList.push(e); }} />
                            {!this.modulesState.stockInNoticeForm.Lines.length && <Divider />}
                            {
                                this.getStockInNoticeTableList()
                            }
                            <Row gutter={20}>
                                <Col span={18} offset={1}>
                                    <Button
                                        className="kts-but-primary"
                                        onClick={ModulesAction.addCommonFormTable}
                                    >
                                        添加一行
                                    </Button>
                                </Col>
                            </Row>
                            <Divider />
                            <StockInNoticeFormAdditional ref={e => { e && this.modulesState.formList.push(e); }} />
                            <div className={css.footer}>
                                <Button htmlType="submit" className="kts-but-default" onClick={this.handleSubmitStockInNotice}>保存</Button>
                                <Button htmlType="submit" className="kts-but-general" onClick={this.sendSubmitStockInNotice} style={{ margin: '0 12px' }}><Icon type="ceshifasong" />发送</Button>
                            </div>
                        </div>
                    }
                    {
                        this.modulesState.documentType === 'Contract' &&
                        <div className={css.content}>
                            <ContractFormBasicInfo ref={e => { e && this.modulesState.formList.push(e); }} />
                            {!this.modulesState.ContractForm.Lines.length && <Divider />}
                            {
                                this.getContractTableList()
                            }
                            <Row gutter={20}>
                                <Col span={18} offset={2}>
                                    <Button
                                        className="kts-but-primary"
                                        onClick={ModulesAction.addCommonFormTable}
                                    >
                                        添加一行
                                    </Button>
                                </Col>
                            </Row>
                            <Divider />
                            <p className={css.total}>总计： {this.modulesState.ContractForm.Total}</p>
                            <ContractFormAdditional ref={e => { e && this.modulesState.formList.push(e); }} />
                            <div className={css.footer}>
                                <Button htmlType="submit" className="kts-but-default" onClick={this.handleSubmitContract}>保存</Button>
                                <Button htmlType="submit" className="kts-but-general" onClick={this.sendSubmitContract} style={{ margin: '0 12px' }}><Icon type="ceshifasong" />发送</Button>
                            </div>
                        </div>
                    }
                </div>
            </Spin>
        );
    }
    /**
     * 渲染中间表格 订单
     */
    private getOrderTableList = () => {
        let list = [];
        this.modulesState.formList = [];
        this.modulesState.orderForm.Lines.forEach((item, index) => {
            list.push(<OrderFormTable onChange={this.onChange} index={index + 1} formData={item} key={this.modulesState.linesKey[index]} ref={e => { e && this.modulesState.formList.push(e); }} />);
        });
        return list;
    }

    /**
     * 渲染中间表格 合同
     */
    private getContractTableList = () => {
        let list = [];
        this.modulesState.formList = [];
        this.modulesState.ContractForm.Lines.forEach((item, index) => {
            list.push(<ContractFormTable onChange={this.onChange} index={index + 1} formData={item} key={this.modulesState.linesKey[index]} ref={e => { e && this.modulesState.formList.push(e); }} />);
        });
        return list;
    }
    /**
     * 渲染中间表格 计划单
     */
    private getForecastTableList = () => {
        let list = [];
        this.modulesState.formList = [];
        this.modulesState.forecastForm.Lines.forEach((item, index) => {
            list.push(<ForecastFormTable onChange={this.onChange} index={index + 1} formData={item} key={this.modulesState.linesKey[index]} ref={e => { e && this.modulesState.formList.push(e); }} />);
        });
        return list;
    }
    /**
     * 渲染中间表格 发货单
     */
    private getDespatchAdviceTableList = () => {
        let list = [];
        this.modulesState.formList = [];
        this.modulesState.despatchAdviceForm.Lines.forEach((item, index) => {
            list.push(<DespatchAdviceFormTable onChange={this.onChange} index={index + 1} formData={item} key={this.modulesState.linesKey[index]} ref={e => { e && this.modulesState.formList.push(e); }} />);
        });
        return list;
    }

    /**
     * 渲染中间表格 收货单
     */
    private getReceiptAdviceTableList = () => {
        let list = [];
        this.modulesState.formList = [];
        this.modulesState.receiptAdviceForm.Lines.forEach((item, index) => {
            list.push(<ReceiptAdviceFormTable onChange={this.onChange} index={index + 1} formData={item} key={this.modulesState.linesKey[index]} ref={e => { e && this.modulesState.formList.push(e); }} />);
        });
        return list;
    }
    /**
     * 渲染中间表格 入库单
     */
    private getStockInNoticeTableList = () => {
        let list = [];
        this.modulesState.formList = [];
        this.modulesState.stockInNoticeForm.Lines.forEach((item, index) => {
            list.push(<StockInNoticeFormTable onChange={this.onChange} index={index + 1} formData={item} key={this.modulesState.linesKey[index]} ref={e => { e && this.modulesState.formList.push(e); }} />);
        });
        return list;
    }
    /**
     * 监听输入变化
     */
    private onChange = () => {
        let lines = [];
        this.modulesState.formList.forEach((item, index) => {
            if (index !== 0 && (this.modulesState.formList.length - 1) !== index) {
                let data = this.modulesState.formList[index].getForm().getFieldsValue();
                lines.push(data);
            }
        });
        ModulesAction.documentCalculate(lines);
    }
    /**
     * 提交 保存 (订单)
     */
    private handleSubmitOrder = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateOrder();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        if (this.modulesState.documentUUID) {
                            // 修改
                            ModulesAction.documentEdit(check);
                        } else {
                            // 新建
                            ModulesAction.documentCreat(check);
                        }
                    }
                });
            // }
        }
    }
    /**
     * 发送 (订单)
     */
    private sendSubmitOrder = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateOrder();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        ModulesAction.documentSend(check);
                    }
                });
            // }
        }
    }
    /**
     * 提交 保存(合同)
     */
    private handleSubmitContract = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateContract();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        if (this.modulesState.documentUUID) {
                            // 修改
                            ModulesAction.documentEdit(check);
                        } else {
                            // 新建
                            ModulesAction.documentCreat(check);
                        }
                    }
                });
            // }
        }
    }
    /**
     * 发送 (合同)
     */
    private sendSubmitContract = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateContract();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        ModulesAction.documentSend(check);
                    }
                });
            // }
        }
    }
    /**
     * 提交 保存
     */
    private handleSubmitForecast = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateForecast();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        if (this.modulesState.documentUUID) {
                            // 修改
                            ModulesAction.documentEdit(check);
                        } else {
                            // 新建
                            ModulesAction.documentCreat(check);
                        }
                    }
                });
            // }
        }
    }
    /**
     * 发送 
     */
    private sendSubmitForecast = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateForecast();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        ModulesAction.documentSend(check);
                    }
                });
            // }
        }
    }

    /**
     * 提交 保存(发货单)
     */
    private handleSubmitDespatchAdvice = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateDespatchAdvice();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        if (this.modulesState.documentUUID) {
                            // 修改
                            ModulesAction.documentEdit(check);
                        } else {
                            // 新建
                            ModulesAction.documentCreat(check);
                        }
                    }
                });
            // }
        }
    }
    /**
     * 发送 (发货单)
     */
    private sendSubmitDespatchAdvice = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateDespatchAdvice();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        ModulesAction.documentSend(check);
                    }
                });
            // }
        }
    }
    /**
     * 提交 保存(收货单)
     */
    private handleSubmitReceiptAdvice = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateReceiptAdvice();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        if (this.modulesState.documentUUID) {
                            // 修改
                            ModulesAction.documentEdit(check);
                        } else {
                            // 新建
                            ModulesAction.documentCreat(check);
                        }
                    }
                });
            // }
        }
    }
    /**
     * 发送 (收货单)
     */
    private sendSubmitReceiptAdvice = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateReceiptAdvice();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        ModulesAction.documentSend(check);
                    }
                });
            // }
        }
    }
    /**
     * 提交 保存(入库单)
     */
    private handleSubmitStockInNotice = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateStockInNotice();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        if (this.modulesState.documentUUID) {
                            // 修改
                            ModulesAction.documentEdit(check);
                        } else {
                            // 新建
                            ModulesAction.documentCreat(check);
                        }
                    }
                });
            // }
        }
    }
    /**
     * 发送 (入库单)
     */
    private sendSubmitStockInNotice = (e) => {
        e.preventDefault();
        let check = ModulesFormAction.checkDateStockInNotice();
        // 验证通过
        if (check) {
            console.log('error:'+this.modulesState.messageInfos.size);
            // if (this.modulesState.messageInfos.size === 0) {
                // 后台验证
                let validateRules = ModulesFormAction.validateDocumentValue().then(() => {
                    if (this.modulesState.messageInfos.size === 0) {
                        ModulesAction.documentSend(check);
                    }
                });
            // }
        }
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.CommonBill.tsx